import React, { Component } from 'react';
import {
  Button, Icon, Input, Spin,
} from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroller';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers } from '@fortawesome/pro-light-svg-icons';
import { Link } from 'react-router-dom';
import BackgroundColorContainer from '../components/other/BackgroundColorContainer';
import {
  Box, Flex, ForEach, Text,
} from '../../shared/components';
import GiotalkHeader from '../components/other/GiotalkHeader';
import { chatSeleccionadoSelector } from '../../../state/selectors/giotalk.selectors';
import {
  establecerChatIdActual,
  enviarMensajeAChat,
  buscarMensajes,
} from '../../../state/actions/creators/giotalk.actioncreator';
import ChatMessage from '../components/dataDisplay/ChatMessage';
import ShowIf from '../../shared/components/dataDisplay/ShowIf';
import { usuariosMappedByIdSelector } from '../../../state/selectors/usuarios.selectors';

class GiotalkChatMostrarPage extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      peticionDeMensajesRealizada: false,
      deseleccionarChat: null,
    };
    this.inputRef = React.createRef();
    this.bottomRef = React.createRef();
  }

  componentDidMount() {
    const { match, establecerChatIdActual } = this.props;
    const { params } = match;
    const { chatId: id } = params;
    establecerChatIdActual({ id });

    setTimeout(() => {
      window.scrollTo(0, document.body.scrollHeight);
    }, 200);
  }

  componentWillUnmount() {
    const { establecerChatIdActual } = this.props;
    establecerChatIdActual({ id: null });
  }

  enviarMensaje() {
    const writtingMessage = this.inputRef.current.state.value;
    this.inputRef.current.state.value = '';
    if (writtingMessage !== undefined && writtingMessage !== null && writtingMessage.replace(/\s/g, '').length !== 0) {
      const { enviarMensajeAChat } = this.props;
      const { chat } = this.props;
      const { id: chatId } = chat;
      enviarMensajeAChat({ mensaje: writtingMessage, chatId });
    }
  }

  cargarMensajesDesdeServidor() {
    const { buscarMensajes, chat, cargandoMensajes: { running: runningCargandoMensajes } } = this.props;
    const { peticionDeMensajesRealizada } = this.state;
    if (runningCargandoMensajes) return;
    if (chat === null || chat === undefined) return;
    const { id, total, mensajes } = chat;
    const mensajesSinUndefined = mensajes || [];
    if (!peticionDeMensajesRealizada || mensajesSinUndefined.length < total) {
      if (peticionDeMensajesRealizada) {
        buscarMensajes({ chatId: id });
      } else {
        buscarMensajes({ chatId: id, primeraCarga: true });
      }
      this.setState({ peticionDeMensajesRealizada: true });
    }
  }

  volverAtras() {
    const { history } = this.props;
    this.setState({ deseleccionarChat: true });
    history.goBack();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.bottomRef) {
      if (this.bottomRef.current) {
        this.bottomRef.current.scrollIntoView({ behavior: 'auto', block: 'end' });
      }
    }
  }

  render() {
    const { cargandoMensajes: { running: runningCargandoMensajes } } = this.props;
    const { chat, usuariosMapped } = this.props;

    if (chat === null || chat === undefined) return <div>Undefined</div>;
    const {
      id: chatId, nombre, mensajes, usuarios,
    } = chat;
    const mensajesSinUndefined = mensajes || [];
    const linkParticipantes = `/talk/chats/${chatId}/participantes`;
    let subtitle = '';
    if (usuarios) {
      usuarios.forEach((usuario) => {
        const { intUser } = usuario;
        const extendedUserInfo = usuariosMapped[intUser];
        if (extendedUserInfo) {
          const { nombre: nombreUsuario } = extendedUserInfo;
          subtitle += `${nombreUsuario}, `;
        }
      });
      subtitle = subtitle.replace(/,\s*$/, '');
    }

    return (
      <BackgroundColorContainer color="#063340">
        <Box>
          <Box position="fixed" width="100%" top="0" p="16" backgroundColor="#063340" style={{ zIndex: 100 }}>
            <GiotalkHeader
              onBackButtonPressed={() => this.volverAtras()}
              title={nombre}
              subtitle={(
                <Text
                  style={{
                    maxWidth: '100%',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                  }}
                  fontSize="12"
                  color="lightgrey"
                >
                  {subtitle}
                </Text>
              )}
              rightContent={(
                <Box>
                  <Link to={linkParticipantes}>
                    <Button ghost style={{ float: 'right' }}>
                      <FontAwesomeIcon icon={faUsers} color="lightgrey" />
                    </Button>
                  </Link>
                </Box>
              )}
            />
          </Box>
          <Box style={{ paddingTop: '100px' }}>
            <InfiniteScroll
              initialLoad
              pageStart={0}
              hasMore
              useWindow
              isReverse
              threshold={100}
              loadMore={() => this.cargarMensajesDesdeServidor()}
            >
              <ShowIf condition={runningCargandoMensajes}>
                <Box mt="16">
                  <Spin
                    style={{ display: 'block', color: 'white', position: 'absolute' }}
                    indicator={
                      <Icon type="loading" style={{ fontSize: 32 }} spin />
                    }
                  />
                </Box>
              </ShowIf>
              <div style={{ paddingTop: '32px' }} />
              <ForEach
                items={mensajesSinUndefined}
                render={(message) => {
                  const { author } = message;
                  const { intUser } = author || { intUser: null };
                  const fromName = (intUser !== null && usuariosMapped[intUser] !== undefined) ? usuariosMapped[intUser].nombre : '';
                  return (<div style={{ padding: '16px', background: '#063340' }}><ChatMessage fromName={fromName} message={message} /></div>);
                }}
              />
              <div ref={this.bottomRef} style={{ paddingBottom: '32px' }} />
            </InfiniteScroll>
          </Box>
          <Box position="fixed" width="100%" bottom="0" backgroundColor="#063340" p="16">
            <Flex>
              <Box flex={4}>
                <Input
                  onPressEnter={() => this.enviarMensaje()}
                  ref={this.inputRef}
                />
              </Box>
              <Box flex={1} ml="8">
                <Button
                  type="primary"
                  block
                  onClick={() => this.enviarMensaje()}
                >
                  Enviar
                </Button>
              </Box>
            </Flex>
          </Box>
        </Box>

      </BackgroundColorContainer>
    );
  }
}

const mapStateToProps = (state) => {
  const { sagas } = state;
  const { GIOTALK_CHATS_MENSAJES_BUSCAR_MENSAJES } = sagas;

  return {
    chat: chatSeleccionadoSelector(state),
    usuariosMapped: usuariosMappedByIdSelector(state),
    cargandoMensajes: GIOTALK_CHATS_MENSAJES_BUSCAR_MENSAJES || { running: false, success: null },
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    establecerChatIdActual,
    enviarMensajeAChat,
    buscarMensajes,
  }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GiotalkChatMostrarPage);

GiotalkChatMostrarPage.propTypes = {};
